module.exports = "<div fxLayout fxLayoutAlign=\"center center\" fxLayoutGap=\"5px\" class=\"indicator\" [ngClass]=\"{'indicator-complete' : completed}\">\r\n  <mat-icon class=\"icon-display\">{{!completed ? 'error_outlined' : 'check_circle_outlined'}}</mat-icon>\r\n  <span>{{!completed ? 'Incompleto' : 'Completo'}}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/indicator/indicator.component.html
// module id = ../../../../../src/app/components/indicator/indicator.component.html
// module chunks = main